import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import { useIsAdmin } from '../hooks/useIsAdmin'

type Props = {
  children: ReactNode
}

export function RequireAdmin({ children }: Props) {
  const { isLoading, isAdmin } = useIsAdmin()

  if (isLoading) return null
  if (!isAdmin) return <Navigate to="/admin/brak-dostepu" replace />
  return <>{children}</>
}

